import confetti from "canvas-confetti";
import { PEOPLE } from "@/lib/spaces";

let ctx;
const ac = () => {
  if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
};

const tone = (f, start, dur, type = "sine", vol = 0.12, fEnd) => {
  const c = ac();
  const t = c.currentTime + start;
  const o = c.createOscillator();
  const g = c.createGain();
  o.type = type;
  o.frequency.setValueAtTime(f, t);
  if (fEnd) o.frequency.exponentialRampToValueAtTime(fEnd, t + dur);
  g.gain.setValueAtTime(vol, t);
  g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
  o.connect(g).connect(c.destination);
  o.start(t);
  o.stop(t + dur + 0.05);
};

const SOUNDS = {
  classic: { done: () => { tone(880, 0, 0.15); tone(1320, 0.12, 0.3); }, alert: () => { tone(660, 0, 0.2); tone(660, 0.25, 0.2); } },
  arcade: { done: () => [523, 659, 784, 1047].forEach((f, i) => tone(f, i * 0.07, 0.12, "square", 0.06)), alert: () => [880, 440, 880].forEach((f, i) => tone(f, i * 0.1, 0.09, "square", 0.06)) },
  duck: { done: () => { tone(700, 0, 0.14, "sawtooth", 0.08, 380); tone(700, 0.2, 0.14, "sawtooth", 0.08, 380); }, alert: () => tone(650, 0, 0.18, "sawtooth", 0.08, 350) },
  trombone: { done: () => [392, 370, 349].forEach((f, i) => tone(f, i * 0.35, 0.35, "triangle", 0.15)) || tone(330, 1.05, 0.9, "triangle", 0.15, 300), alert: () => tone(196, 0, 0.6, "triangle", 0.15, 180) },
};

export const SOUND_PACKS = [
  { value: "classic", label: "Classic ping" }, { value: "arcade", label: "Retro arcade" },
  { value: "duck", label: "Duck quack" }, { value: "trombone", label: "Sad trombone" },
];

export const airhorn = () => [0, 0.45].forEach((s) => [440, 554, 659].forEach((f) => tone(f, s, 0.38, "sawtooth", 0.07)));

export const playSound = (pack, kind = "done") => {
  try { (SOUNDS[pack] || SOUNDS.classic)[kind](); } catch { /* audio is best-effort */ }
};

const shapes = (texts) => texts.map((text) => confetti.shapeFromText({ text, scalar: 2.2 }));

export const CONFETTI_STYLES = [
  { value: "classic", label: "Classic confetti" }, { value: "fireworks", label: "Fireworks" },
  { value: "emoji", label: "Emoji rain" }, { value: "faces", label: "Team face rain" },
];

export const fireConfetti = (style = "classic") => {
  if (style === "fireworks") {
    [0, 250, 500, 750].forEach((d) => setTimeout(() => confetti({ particleCount: 70, spread: 360, startVelocity: 30, origin: { x: 0.2 + Math.random() * 0.6, y: 0.2 + Math.random() * 0.3 } }), d));
  } else if (style === "emoji" || style === "faces") {
    const txt = style === "faces" ? PEOPLE.map((p) => p.emoji || p.name[0]) : ["🎉", "🚀", "⭐", "🔥", "✅"];
    confetti({ particleCount: 40, spread: 100, origin: { y: 0.6 }, shapes: shapes(txt), scalar: 2.2, ticks: 220 });
  } else {
    confetti({ particleCount: 140, spread: 85, origin: { y: 0.7 } });
  }
};

export const SASS = [
  "Still here. Waiting. Patiently.", "I'm not angry, just disappointed.", "Remember me? Because I remember you.",
  "This task has started writing its memoirs.", "Tick me off. I dare you.", "I've seen glaciers move faster.",
  "Your future self is begging you.", "I'll just sit here then.",
];
export const sassFor = (id = "") => SASS[[...id].reduce((a, c) => a + c.charCodeAt(0), 0) % SASS.length];

const KONAMI = ["ArrowUp", "ArrowUp", "ArrowDown", "ArrowDown", "ArrowLeft", "ArrowRight", "ArrowLeft", "ArrowRight", "b", "a"];
export const konamiListener = (onHit) => {
  let i = 0;
  const h = (e) => {
    i = e.key === KONAMI[i] ? i + 1 : e.key === KONAMI[0] ? 1 : 0;
    if (i === KONAMI.length) { i = 0; onHit(); }
  };
  window.addEventListener("keydown", h);
  return () => window.removeEventListener("keydown", h);
};
